import { Component, Input } from '@angular/core'
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-dialog-error-details',
  templateUrl: './dialog-error-details.component.html',
  styleUrls: ['./dialog-error-details.component.scss'],
})
export class DialogErrorDetailsComponent {
  isCopying = false
  @Input()
  errorDetails: unknown

  @Input()
  errorHeader: string | undefined

  copyError() {
    this.isCopying = true
    navigator.clipboard.writeText(JSON.stringify(this.errorDetails))
  }
  beforePanelChange = (event: NgbPanelChangeEvent) => {
    if (this.isCopying) {
      event.preventDefault()
      this.isCopying = false
    }
  }
}
